<template>
  <b-row align-v="center" class="justify-content-start m-1" no-gutters>
    <b-col md="auto" class="ml-4">
      <span>전화번호</span>
    </b-col>

    <b-col cols="3" class="ml-2">
      <b-input-group size="sm">
        <b-form-input v-model="data.phoneNo"></b-form-input>
      </b-input-group>
    </b-col>

    <b-col md="auto" class="ml-3">
<!--      <b-button variant="outline-success" class="mb-2 mr-sm-3 mb-sm-0" size="xs" @click="onClickDelete" :hidden="params.id < 1">삭제-->
      <b-button variant="outline-success" class="mb-2 mr-sm-3 mb-sm-0" size="xs" @click="deleteNumber">삭제
      </b-button>
    </b-col>

  </b-row>

</template>

<script>
  export default {
    props: ['data'],
    data() {
      return {
        // params: {
        //   id: null
        // },
      }
    },

    mounted() {
    },

    methods: {
      deleteNumber() {
        this.$emit('deleteNumber', this.data.id)
      }
    }
  }
</script>
